var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipMetalDeck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-5, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #b4b4b4;\r\n      }\r\n\r\n      .cls-5, .cls-6 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.24px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipMetalDeck") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LayerMetalDeck"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.37 24.61 4.38 24.58 3.6 23.55 2.89 23.3 2.1 23.76 2.12 23.8 2.9 23.34 3.59 23.58 3.9 24 4.37 24.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.1 23.76 3.6 22.9 6.26 21.4 5.01 21.35 1.25 23.45 2.1 23.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4.38 24.58 9.72 21.59 8.55 20.78 3.6 23.55 4.37 24.56 4.38 24.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.6 23.55 8.55 20.78 7.48 20.72 2.89 23.3 3.6 23.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.5 25.74 7.51 25.71 6.73 24.68 6.02 24.42 5.23 24.89 5.25 24.93 6.03 24.46 6.71 24.71 7.5 25.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5.23 24.89 7.57 23.55 10.96 21.65 9.72 21.59 4.38 24.58 5.23 24.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7.51 25.71 14.41 21.84 13.24 21.03 6.73 24.68 7.5 25.69 7.51 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.73 24.68 13.24 21.03 12.17 20.97 6.02 24.42 6.73 24.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "10.63 26.87 10.64 26.83 9.86 25.8 9.14 25.55 8.36 26.01 8.37 26.05 9.16 25.59 9.85 25.84 10.63 26.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.36 26.01 10.7 24.68 15.65 21.9 14.41 21.84 7.51 25.71 8.36 26.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "10.64 26.83 19.11 22.09 17.93 21.28 9.86 25.8 10.63 26.82 10.64 26.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.86 25.8 17.93 21.28 16.87 21.22 9.14 25.55 9.86 25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.76 27.99 13.77 27.96 12.99 26.93 12.27 26.68 11.49 27.14 11.5 27.18 12.29 26.72 12.97 26.96 13.76 27.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.49 27.14 13.83 25.8 20.34 22.15 19.11 22.09 10.64 26.83 11.49 27.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "13.77 27.96 23.8 22.34 22.63 21.53 12.99 26.93 13.76 27.94 13.77 27.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.99 26.93 22.63 21.53 21.5 21.51 12.27 26.68 12.99 26.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.89 29.12 16.9 29.09 16.11 28.06 15.4 27.8 14.62 28.27 14.63 28.31 15.41 27.84 16.1 28.09 16.89 29.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.62 28.27 17.13 26.83 25.04 22.4 23.8 22.34 13.77 27.96 14.62 28.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.9 29.09 28.5 22.59 27.32 21.78 16.11 28.06 16.89 29.07 16.9 29.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.11 28.06 27.32 21.78 26.25 21.72 15.4 27.8 16.11 28.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.02 30.25 20.03 30.21 19.24 29.18 18.53 28.93 17.75 29.39 17.76 29.43 18.54 28.97 19.23 29.22 20.02 30.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.75 29.39 20.26 27.96 29.73 22.65 28.5 22.59 16.9 29.09 17.75 29.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "20.03 30.21 33.19 22.84 32.02 22.03 19.24 29.18 20.02 30.2 20.03 30.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "19.24 29.18 32.02 22.03 30.95 21.97 18.53 28.93 19.24 29.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.14 31.37 23.16 31.34 22.37 30.31 21.66 30.05 20.88 30.52 20.89 30.56 21.67 30.1 22.36 30.34 23.14 31.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.88 30.52 23.39 29.09 34.42 22.9 33.19 22.84 20.03 30.21 20.88 30.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.16 31.34 37.88 23.09 36.71 22.28 22.37 30.31 23.14 31.32 23.16 31.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.37 30.31 36.71 22.28 35.64 22.22 21.66 30.05 22.37 30.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.27 32.5 26.29 32.47 25.5 31.44 24.79 31.18 24 31.64 24.02 31.69 24.8 31.22 25.49 31.47 26.27 32.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.01 31.64 26.52 30.21 39.12 23.15 37.88 23.09 23.16 31.34 24 31.64 24.01 31.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "26.29 32.47 42.58 23.34 41.4 22.53 25.5 31.44 26.29 32.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.5 31.44 41.4 22.53 40.34 22.47 24.79 31.18 25.5 31.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.58 21.51 46.35 19.4 21.3 10.38 5.01 19.51 24 20.52 42.58 21.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.58 23.3 42.58 21.51 5.01 19.51 5.01 21.3 6.32 21.37 7.5 20.72 8.55 20.78 9.72 21.55 11.02 21.62 12.17 20.97 13.24 21.03 14.41 21.8 15.71 21.87 16.89 21.22 17.93 21.28 19.13 22.05 20.41 22.12 21.58 21.47 22.63 21.53 23.8 22.3 25.1 22.37 26.27 21.72 27.32 21.78 28.51 22.55 29.79 22.62 30.97 21.97 32.02 22.03 33.21 22.8 34.49 22.87 35.66 22.22 36.71 22.28 37.9 23.05 39.18 23.12 40.35 22.47 41.4 22.53 42.52 23.3 42.58 23.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "42.58 23.3 46.35 21.19 46.35 19.4 42.58 21.51 42.58 23.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.1,
    y1: 23.76,
    x2: 1.25,
    y2: 23.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1.25,
    y1: 23.45,
    x2: 1.24,
    y2: 23.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1.24,
    y1: 23.49,
    x2: 2.12,
    y2: 23.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.12,
    y1: 23.8,
    x2: 2.9,
    y2: 23.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.9,
    y1: 23.34,
    x2: 3.59,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3.59,
    y1: 23.58,
    x2: 4.37,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.37,
    y1: 24.61,
    x2: 4.38,
    y2: 24.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.38,
    y1: 24.58,
    x2: 3.6,
    y2: 23.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3.6,
    y1: 23.55,
    x2: 2.89,
    y2: 23.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.89,
    y1: 23.3,
    x2: 2.1,
    y2: 23.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.26,
    y1: 21.4,
    x2: 5.03,
    y2: 21.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.03,
    y1: 21.34,
    x2: 1.25,
    y2: 23.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2.93,
    y1: 23.35,
    x2: 2.12,
    y2: 23.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.72,
    y1: 21.59,
    x2: 4.38,
    y2: 24.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.72,
    y1: 21.59,
    x2: 8.55,
    y2: 20.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 8.55,
    y1: 20.78,
    x2: 3.6,
    y2: 23.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 8.55,
    y1: 20.78,
    x2: 7.48,
    y2: 20.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.48,
    y1: 20.72,
    x2: 2.89,
    y2: 23.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.23,
    y1: 24.89,
    x2: 4.38,
    y2: 24.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.38,
    y1: 24.58,
    x2: 4.37,
    y2: 24.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 4.37,
    y1: 24.61,
    x2: 5.25,
    y2: 24.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 5.25,
    y1: 24.93,
    x2: 6.03,
    y2: 24.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.03,
    y1: 24.46,
    x2: 6.72,
    y2: 24.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.72,
    y1: 24.71,
    x2: 7.5,
    y2: 25.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.5,
    y1: 25.74,
    x2: 7.51,
    y2: 25.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.51,
    y1: 25.71,
    x2: 6.73,
    y2: 24.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.73,
    y1: 24.68,
    x2: 6.02,
    y2: 24.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.02,
    y1: 24.42,
    x2: 5.23,
    y2: 24.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.96,
    y1: 21.65,
    x2: 9.72,
    y2: 21.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.72,
    y1: 21.59,
    x2: 4.38,
    y2: 24.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.06,
    y1: 24.47,
    x2: 5.25,
    y2: 24.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.41,
    y1: 21.84,
    x2: 7.51,
    y2: 25.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.41,
    y1: 21.84,
    x2: 13.24,
    y2: 21.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.24,
    y1: 21.03,
    x2: 6.73,
    y2: 24.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.24,
    y1: 21.03,
    x2: 12.17,
    y2: 20.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.17,
    y1: 20.97,
    x2: 6.02,
    y2: 24.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 8.36,
    y1: 26.01,
    x2: 7.51,
    y2: 25.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.51,
    y1: 25.71,
    x2: 7.5,
    y2: 25.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 7.5,
    y1: 25.74,
    x2: 8.37,
    y2: 26.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 8.37,
    y1: 26.05,
    x2: 9.16,
    y2: 25.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.16,
    y1: 25.59,
    x2: 9.84,
    y2: 25.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.84,
    y1: 25.84,
    x2: 10.63,
    y2: 26.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.63,
    y1: 26.87,
    x2: 10.64,
    y2: 26.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.64,
    y1: 26.83,
    x2: 9.86,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.86,
    y1: 25.8,
    x2: 9.14,
    y2: 25.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.14,
    y1: 25.55,
    x2: 8.36,
    y2: 26.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 15.65,
    y1: 21.9,
    x2: 14.41,
    y2: 21.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.41,
    y1: 21.84,
    x2: 7.51,
    y2: 25.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 9.19,
    y1: 25.6,
    x2: 8.37,
    y2: 26.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.11,
    y1: 22.09,
    x2: 10.64,
    y2: 26.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.11,
    y1: 22.09,
    x2: 17.93,
    y2: 21.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.93,
    y1: 21.28,
    x2: 9.86,
    y2: 25.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.93,
    y1: 21.28,
    x2: 16.87,
    y2: 21.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.87,
    y1: 21.22,
    x2: 9.14,
    y2: 25.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.49,
    y1: 27.14,
    x2: 10.64,
    y2: 26.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.64,
    y1: 26.83,
    x2: 10.63,
    y2: 26.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 10.63,
    y1: 26.87,
    x2: 11.5,
    y2: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 11.5,
    y1: 27.18,
    x2: 12.29,
    y2: 26.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.29,
    y1: 26.72,
    x2: 12.97,
    y2: 26.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.97,
    y1: 26.96,
    x2: 13.76,
    y2: 27.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.76,
    y1: 27.99,
    x2: 13.77,
    y2: 27.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.77,
    y1: 27.96,
    x2: 12.99,
    y2: 26.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.99,
    y1: 26.93,
    x2: 12.27,
    y2: 26.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.27,
    y1: 26.67,
    x2: 11.49,
    y2: 27.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.34,
    y1: 22.15,
    x2: 19.11,
    y2: 22.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.11,
    y1: 22.09,
    x2: 10.64,
    y2: 26.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 12.31,
    y1: 26.73,
    x2: 11.5,
    y2: 27.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.8,
    y1: 22.34,
    x2: 13.77,
    y2: 27.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.8,
    y1: 22.34,
    x2: 22.63,
    y2: 21.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.63,
    y1: 21.53,
    x2: 12.99,
    y2: 26.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.63,
    y1: 21.53,
    x2: 21.56,
    y2: 21.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 21.56,
    y1: 21.47,
    x2: 12.27,
    y2: 26.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.62,
    y1: 28.27,
    x2: 13.77,
    y2: 27.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.77,
    y1: 27.96,
    x2: 13.76,
    y2: 27.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 13.76,
    y1: 27.99,
    x2: 14.63,
    y2: 28.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 14.63,
    y1: 28.31,
    x2: 15.42,
    y2: 27.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 15.42,
    y1: 27.84,
    x2: 16.1,
    y2: 28.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.1,
    y1: 28.09,
    x2: 16.89,
    y2: 29.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.89,
    y1: 29.12,
    x2: 16.9,
    y2: 29.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.9,
    y1: 29.09,
    x2: 16.11,
    y2: 28.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.11,
    y1: 28.06,
    x2: 15.4,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 15.4,
    y1: 27.8,
    x2: 14.62,
    y2: 28.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 25.04,
    y1: 22.4,
    x2: 23.8,
    y2: 22.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.8,
    y1: 22.34,
    x2: 13.77,
    y2: 27.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 15.44,
    y1: 27.85,
    x2: 14.63,
    y2: 28.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 28.5,
    y1: 22.59,
    x2: 16.9,
    y2: 29.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 28.5,
    y1: 22.59,
    x2: 27.32,
    y2: 21.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 27.32,
    y1: 21.78,
    x2: 16.11,
    y2: 28.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 27.32,
    y1: 21.78,
    x2: 26.25,
    y2: 21.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 26.25,
    y1: 21.72,
    x2: 15.4,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.75,
    y1: 29.39,
    x2: 16.9,
    y2: 29.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.9,
    y1: 29.09,
    x2: 16.89,
    y2: 29.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 16.89,
    y1: 29.12,
    x2: 17.76,
    y2: 29.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.76,
    y1: 29.43,
    x2: 18.54,
    y2: 28.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 18.54,
    y1: 28.97,
    x2: 19.23,
    y2: 29.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.23,
    y1: 29.22,
    x2: 20.01,
    y2: 30.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.01,
    y1: 30.24,
    x2: 20.03,
    y2: 30.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.03,
    y1: 30.21,
    x2: 19.24,
    y2: 29.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 19.24,
    y1: 29.18,
    x2: 18.53,
    y2: 28.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 18.53,
    y1: 28.93,
    x2: 17.75,
    y2: 29.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 29.73,
    y1: 22.65,
    x2: 28.5,
    y2: 22.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 28.5,
    y1: 22.59,
    x2: 16.9,
    y2: 29.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 18.57,
    y1: 28.98,
    x2: 17.76,
    y2: 29.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 33.19,
    y1: 22.84,
    x2: 20.03,
    y2: 30.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 33.19,
    y1: 22.84,
    x2: 32.02,
    y2: 22.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 32.02,
    y1: 22.03,
    x2: 19.24,
    y2: 29.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 32.02,
    y1: 22.03,
    x2: 30.95,
    y2: 21.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 30.95,
    y1: 21.97,
    x2: 18.53,
    y2: 28.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.88,
    y1: 30.52,
    x2: 20.03,
    y2: 30.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.03,
    y1: 30.21,
    x2: 20.01,
    y2: 30.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.01,
    y1: 30.24,
    x2: 20.89,
    y2: 30.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 20.89,
    y1: 30.56,
    x2: 21.67,
    y2: 30.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 21.67,
    y1: 30.1,
    x2: 22.36,
    y2: 30.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.36,
    y1: 30.34,
    x2: 23.14,
    y2: 31.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.14,
    y1: 31.37,
    x2: 23.16,
    y2: 31.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.16,
    y1: 31.34,
    x2: 22.37,
    y2: 30.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.37,
    y1: 30.31,
    x2: 21.66,
    y2: 30.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 21.66,
    y1: 30.05,
    x2: 20.88,
    y2: 30.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 34.43,
    y1: 22.9,
    x2: 33.19,
    y2: 22.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 33.19,
    y1: 22.84,
    x2: 20.03,
    y2: 30.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 21.7,
    y1: 30.11,
    x2: 20.89,
    y2: 30.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.88,
    y1: 23.09,
    x2: 23.16,
    y2: 31.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.88,
    y1: 23.09,
    x2: 36.71,
    y2: 22.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 36.71,
    y1: 22.28,
    x2: 22.37,
    y2: 30.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 36.71,
    y1: 22.28,
    x2: 35.64,
    y2: 22.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.64,
    y1: 22.22,
    x2: 21.66,
    y2: 30.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.01,
    y1: 31.65,
    x2: 23.16,
    y2: 31.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.16,
    y1: 31.34,
    x2: 23.14,
    y2: 31.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 23.14,
    y1: 31.37,
    x2: 24,
    y2: 31.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.02,
    y1: 31.69,
    x2: 24.8,
    y2: 31.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.8,
    y1: 31.22,
    x2: 25.49,
    y2: 31.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 25.49,
    y1: 31.47,
    x2: 26.27,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 26.27,
    y1: 32.5,
    x2: 26.28,
    y2: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 26.28,
    y1: 32.46,
    x2: 25.5,
    y2: 31.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 25.5,
    y1: 31.44,
    x2: 24.79,
    y2: 31.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.79,
    y1: 31.18,
    x2: 24.01,
    y2: 31.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 39.12,
    y1: 23.15,
    x2: 37.88,
    y2: 23.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 37.88,
    y1: 23.09,
    x2: 23.16,
    y2: 31.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.83,
    y1: 31.23,
    x2: 24.02,
    y2: 31.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42.56,
    y1: 23.37,
    x2: 26.27,
    y2: 32.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42.56,
    y1: 23.37,
    x2: 42.58,
    y2: 23.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42.58,
    y1: 23.34,
    x2: 26.28,
    y2: 32.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42.58,
    y1: 23.34,
    x2: 41.4,
    y2: 22.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.4,
    y1: 22.53,
    x2: 25.5,
    y2: 31.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 41.4,
    y1: 22.53,
    x2: 40.34,
    y2: 22.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 40.34,
    y1: 22.47,
    x2: 24.79,
    y2: 31.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 42.58,
    y1: 23.3,
    x2: 42.52,
    y2: 23.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 39.18,
    y1: 23.12,
    x2: 37.82,
    y2: 23.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 34.49,
    y1: 22.87,
    x2: 33.13,
    y2: 22.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 29.79,
    y1: 22.62,
    x2: 28.44,
    y2: 22.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 25.1,
    y1: 22.37,
    x2: 23.74,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 20.4,
    y1: 22.12,
    x2: 19.05,
    y2: 22.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 15.71,
    y1: 21.87,
    x2: 14.36,
    y2: 21.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 11.02,
    y1: 21.62,
    x2: 9.66,
    y2: 21.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 6.32,
    y1: 21.37,
    x2: 5.01,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 46.35,
    y1: 21.19,
    x2: 42.58,
    y2: 23.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 42.58,
    y1: 21.51,
    x2: 46.35,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 46.35,
    y1: 19.4,
    x2: 21.3,
    y2: 10.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.3,
    y1: 10.38,
    x2: 5.01,
    y2: 19.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 5.01,
    y1: 19.51,
    x2: 42.58,
    y2: 21.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 42.58,
    y1: 23.3,
    x2: 42.58,
    y2: 21.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 5.01,
    y1: 19.51,
    x2: 5.01,
    y2: 21.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 46.35,
    y1: 19.4,
    x2: 46.35,
    y2: 21.19
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipMetalDeck);
export default __webpack_public_path__ + "static/media/IconChipMetalDeck.350c5a23acb7fa3b38c1cd5bacde4c80.svg";
export { ForwardRef as ReactComponent };